<template>
    <div
        v-loading="false"
        class="w-full h-full relative flex gap-3">
        <!-- Map -->
        <div class="w-full h-full">
            <hts-map
                ref="dataMap"
                :zoom="11"
                :routing-data="routingOption"
                :polyline-data="routingIsSelected ? routingIsSelected.routing : []"
                :travel-modes="dataFormSubmitRouting.travelModes"
                :draggable="draggable"
                map-style="height: 550px"
                @data-information="handelDataInformation"
                @update-routing="(data: any, tollStationList: any, path: any) => handleUpdateRouting(data, tollStationList, path)"
                @update-center-point="handleRoutingCenterPoint">
                <template #selectVehicle>
                    <div class="flex flex-col gap-5">
                        <hts-form-select
                            v-model="dataFormSubmitRouting.travelModes"
                            :label="$t('labels.routingModule.travelModes')"
                            :required="true"
                            :items="travelModesList"
                            key-id="value"
                            key-label="label"
                            :disabled="disabled"
                            name="travelModes"
                            prop="travelModes" />
                        <div>
                            <span>
                                {{ $t('labels.vehicleType') }}
                                <span class="text-error-500">
                                    *
                                </span>
                            </span>
                            <div v-if="vehicleCategoryListName && vehicleCategoryListName.length">
                                <div
                                    v-for="(item, index) in vehicleCategoryListName"
                                    :key="index">
                                    <span>
                                        {{ item }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="!disabled"
                                class="flex items-center justify-center">
                                <div
                                    class="h-7 w-7 mt-3 cursor-pointer border-2 border-orange-500 rounded-full flex items-center justify-center"
                                    @click="handleOpenModal">
                                    <hi-plus-icon class="h-5 w-5 fill-orange-700" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template #selectRouting>
                    <div
                        v-if="showSelectRouting"
                        class="h-5/6">
                        <h3 class="title">
                            <span class="label">
                                {{ $t('labels.routingModule.selectRouting') }}
                            </span>
                        </h3>
                        <input-routing
                            :disabled="disabled"
                            :routing-info="routingList" />
                        <div
                            class="h-full w-full mt-5 p-2 text-center shadow border rounded-b-md bg-orange-600 cursor-pointer"
                            @click="handleShowSelectRouting">
                            <span class="font-bold text-white">
                                {{ $t('labels.hide') }}
                            </span>
                        </div>
                    </div>
                    <div
                        v-else
                        class="h-full w-full p-2 text-center shadow border rounded-b-md bg-orange-600 cursor-pointer"
                        @click="handleShowSelectRouting">
                        <span class="font-bold text-white">
                            {{ $t('labels.show') }}
                        </span>
                    </div>
                </template>
                <template #viewInformation>
                    <!-- Information -->
                    <div v-if="showViewInformation">
                        <div class="flex justify-center items-center">
                            <h3>
                                <span class="label">
                                    {{ $t('labels.routingModule.routingInfo') }}
                                </span>
                            </h3>
                        </div>
                        <div
                            v-if="loading"
                            class="hts-loading loading">
                            <div class="hts-loading__dot-fire" />
                        </div>
                        <div
                            v-else
                            class="pl-1 text-base flex flex-col gap-5 overflow-auto"
                            style="max-height: 300px">
                            <div v-if="routingList && routingList.length">
                                <p>
                                    - {{ $t('labels.route') }}: {{ routingList[0].name }} - {{ routingList[routingList.length - 1].name }}
                                </p>
                            </div>
                            <p>
                                - {{ $t('labels.distance') }}: {{ dataFormSubmitRouting.distanceDetail ? dataFormSubmitRouting.distanceDetail.text : '' }} --->
                                {{ dataFormSubmitRouting.distanceCenterPoint }}
                            </p>
                            <p>
                                - {{ $t('labels.estimateTime') }}: {{ dataFormSubmitRouting.timeDetail ? dataFormSubmitRouting.timeDetail.text : '' }} --->
                                {{ dataFormSubmitRouting.timeCenterPoint || 0 }} km
                            </p>
                            <div v-if="dataFormSubmitRouting.tollStation[0] && dataFormSubmitRouting.tollStation[0].name">
                                <p>
                                    - {{ $t('labels.numberOfTollStation') }}: {{ dataFormSubmitRouting.tollStation ? dataFormSubmitRouting.tollStation.length : 0 }}
                                </p>
                                <div
                                    v-for="(item, index) in dataFormSubmitRouting.tollStation"
                                    :key="index">
                                    <span class="pl-3">
                                        + {{ item.name || '' }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-for="(item, index) in dataFormSubmitRouting.routesCenterPoint"
                                :key="index">
                                <span class="pl-3">
                                    + {{ item || '' }}
                                </span>
                            </div>
                        </div>
                        <div
                            class="h-full w-full mt-5 p-2 text-center shadow border rounded-b-md bg-orange-600 cursor-pointer"
                            @click="handleShowViewInformation">
                            <span class="font-bold text-white">
                                {{ $t('labels.hide') }}
                            </span>
                        </div>
                    </div>
                    <div
                        v-else
                        class="h-full w-full p-2 text-center shadow border rounded-b-md bg-orange-600 cursor-pointer"
                        @click="handleShowViewInformation">
                        <span class="font-bold text-white">
                            {{ $t('labels.show') }}
                        </span>
                    </div>
                </template>
            </hts-map>
        </div>

        <!-- Button -->
        <div v-if="!disabled">
            <div
                v-if="step === 3"
                class="absolute right-20 bottom-10">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    @click="handleSubmit">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
            <div
                v-else
                class="absolute right-20 bottom-10">
                <hts-form-button
                    icon-name="hi-arrow-right-icon"
                    icon-position="right"
                    color="primary"
                    @click="handleStep">
                    {{ $t('labels.nextScreen') }}
                </hts-form-button>
            </div>
        </div>
        <hts-modal
            :show="showModal"
            :size="50"
            @hide="showModal = false">
            <hts-select-category-vehicle
                v-model="vehicleCategoryId"
                v-model:name="vehicleCategoryName"
                prop="vehicles" />
            <div class="absolute bottom-6 right-6">
                <div class="flex justify-end gap-5">
                    <div class="absolute right-20 bottom-10">
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            @click="handleAddVehicleCategory">
                            {{ $t('labels.save') }}
                        </hts-form-button>
                    </div>
                    <hts-form-button
                        icon-name="hi-x-mark-icon"
                        icon-position="right"
                        color="error"
                        @click="showModal = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>
    </div>
</template>
<script setup lang="ts">
import form, { ETravelModes } from '../imports/form'
import { formatDistanceToKm, formatTime } from '../imports/utils'
import InputRouting from '../component/input-routing.vue'
import SelectVehicleCategory from '@/pages/trucker-[id]/vehicle/ignore/autocomplete/select-vehicle-category.vue'

const props = defineProps({
  routingOption: {
    default: () => [],
    type: Array<Object>
  },
  disabled: {
    type: Boolean,
    default: false
  },
  routingIsSelected: {
    type: Object,
    default: () => {}
  },
  action: {
    type: String,
    default: ''
  }
})
const dataMap = ref()
const { routingOption } = toRefs(props)
onMounted(() => {
  routingOption.value.map((item: any) => {
    delete item.isHover
    return item
  })
})
watch(
  () => routingOption.value,
  (currentValue: any, oldValue: any) => {
    routingOption.value.map((item: any) => {
      delete item.isHover
      return item
    })
  },
  { deep: true }
)
const dataFormSubmitRouting = reactive({ ...form.initValue })
const routingList = computed(() => {
  return props.routingOption
})
const loading = ref(false)
const showModal = ref(false)
const vehicleCategoryId = ref('')
const vehicleCategoryName = ref('')
const vehicleCategoryList = ref<Array<string>>([])
const vehicleCategoryListName = ref<Array<string>>([])
const showSelectRouting = ref(false)
const showViewInformation = ref(false)
const step = ref<number>(0)
const visibleSubmit = ref<boolean>(false)
const draggable = ref<boolean>(false)

watch(props, () => {
  if (props.routingIsSelected && Object.keys(props.routingIsSelected).length) {
    Object.assign(dataFormSubmitRouting, {
      ...props.routingIsSelected,
      distanceDetail: {
        text: `${props.routingIsSelected.distance} km`,
        value: props.routingIsSelected.distance
      },
      timeDetail: {
        text: formatTime(props.routingIsSelected.time),
        value: props.routingIsSelected.time
      }
    })
    // vehicleCategoryListName = dataFormSubmitRouting.vehicleTypesName
    vehicleCategoryListName.value = dataFormSubmitRouting.vehicleTypesName
    vehicleCategoryList.value = dataFormSubmitRouting.vehicleTypes
  }
})
const travelModesList = [
  {
    label: 'Driving',
    value: ETravelModes.DRIVING
  },
  {
    label: 'Walking',
    value: ETravelModes.WALKING
  },
  {
    label: 'Bicycling',
    value: ETravelModes.BICYCLING
  },
  {
    label: 'Transit',
    value: ETravelModes.TRANSIT
  }
]
const handleUpdateRouting = (data: any, tollStationList: any, path: any) => {
  const overviewPath: Array<{ [key: string]: any }> = []
  data?.routes[0].overview_path.forEach((item: any) => {
    overviewPath.push({ lat: item.lat(), long: item.lng() })
  })
  loading.value = true
  if (!data) {
    return null
  }
  const { distance, duration } = data.routes[0].legs[0]
  Object.assign(dataFormSubmitRouting, {
    ...dataFormSubmitRouting,
    node: routingList.value,
    distanceDetail: distance,
    timeDetail: duration,
    tollStation: tollStationList,
    routing: path,
    overviewPath
  })
  setTimeout(() => {
    loading.value = false
  }, 1500)
}
const handleChangeInputVehicleCategory = (vehicleCategoryData: any, vehicleCategoryDetail: any) => {
  if (!vehicleCategoryData) {
    return null
  }
  vehicleCategoryId.value = vehicleCategoryData._id
  vehicleCategoryName.value = vehicleCategoryData.name
}
const handleAddVehicleCategory = () => {
  const checkExist = vehicleCategoryList.value.find((item: any) => item === vehicleCategoryId)
  if (checkExist) {
    return $toast().error($t('validations.vehicleCategoryIsExist'))
  }
  vehicleCategoryList.value.push(vehicleCategoryId.value)
  vehicleCategoryListName.value.push(vehicleCategoryName.value)
  showModal.value = false
}
const handleOpenModal = () => {
  showModal.value = true
}
const handleShowSelectRouting = () => {
  showSelectRouting.value = !showSelectRouting.value
}
const handleShowViewInformation = () => {
  showViewInformation.value = !showViewInformation.value
}
const handleSubmit = () => {
  if (props.action === 'create') {
    createRouting()
  } else {
    editRouting()
  }
}
const createRouting = () => {
  const api = $url.routing.addRouting
  Object.assign(dataFormSubmitRouting, {
    ...dataFormSubmitRouting,
    vehicleTypes: vehicleCategoryList,
    vehicleTypesName: vehicleCategoryListName,
    distance: formatDistanceToKm(dataFormSubmitRouting.distanceDetail.value),
    time: dataFormSubmitRouting.distanceDetail.value
  })
  $api(api, { body: { ...dataFormSubmitRouting } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.routingModule.addSuccess'))
        useRouter().push({
          name: 'trucker-id-routing-list',
          params: {}
        })
      }
    })
    .catch((error: any) => error)
}
const editRouting = () => {
  const api = $url.routing.update
  Object.assign(dataFormSubmitRouting, {
    ...dataFormSubmitRouting,
    id: props.routingIsSelected._id,
    vehicleTypes: vehicleCategoryList,
    vehicleTypesName: vehicleCategoryListName,
    distance: formatDistanceToKm(dataFormSubmitRouting.distanceDetail.value),
    time: dataFormSubmitRouting.distanceDetail.value
  })
  $api(api, { body: { ...dataFormSubmitRouting } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        process.client && $toast().success($t('labels.routingModule.editSuccess'))
        useRouter().push({
          name: 'trucker-id-routing-list',
          params: {}
        })
      }
    })
    .catch((error: any) => error)
}

const dataTollStation = ref()

const dataOverviewPath = ref<Array<{ [key: string]: any }>>([])
const directionsRendererFunction = ref<google.maps.DirectionsRenderer | null>(null)
const handelDataInformation = (routing: google.maps.DirectionsRenderer, routingCompare: google.maps.DirectionsRenderer, mapGender: google.maps.Map) => {
  const overviewPath: Array<{ [key: string]: any }> = []
  const overviewPathCompare: Array<{ [key: string]: any }> = []
  directionsRendererFunction.value = routing
  // if (routingCompare) {
  //   const getRoutingCompare = routingCompare.getDirections()
  //   getRoutingCompare?.routes[0].overview_path.forEach((item:any) => {
  //     overviewPathCompare.push({ lat: item.lat(), lng: item.lng() })
  //   })
  // }
  if (routing) {
    const getRouting = routing.getDirections()
    getRouting?.routes[0].overview_path.forEach((item: any) => {
      overviewPath.push({ lat: item.lat(), lng: item.lng() })
    })
  }
  dataOverviewPath.value = overviewPath
  // const api = {
  //   method: 'post',
  //   url: '/routing/station'
  // }
  // $api(api, { body: { overviewPath } })
  //   .then((data) => {
  //     if (!data) { return true }
  //     const responseData:any = data.data.value
  //     dataTollStation.value = responseData
  //   }).catch((error:any) => error)
}
const handleStep = async () => {
  switch (step.value) {
  case 0:
    if (!directionsRendererFunction.value) {
      return $toast().error($t('validations.emptyRouting'))
    }
    await getCenterPointAndTollStation()
    break
  default:
    return 2
  }
}

const requestAddLine = ref()
const getCenterPointAndTollStation = () => {
  const api = {
    method: 'post',
    url: '/routing/station'
  }
  $api(api, { body: { overviewPath: dataOverviewPath.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      dataTollStation.value = responseData
      requestAddLine.value = {
        origin: responseData.data.dataRouting[0],
        destination: responseData.data.dataRouting[responseData.data.dataRouting.length - 1],
        waypoints: responseData.data.waitPoint,
        travelMode: 'DRIVING'
      }

      dataMap.value.addLine(responseData.data.dataRouting, responseData.data.dataWaitPointGroup)
      // step.value += 1
    })
    .catch((error: any) => {
      return error
    })
}
const handleRoutingCenterPoint = (data: any) => {
  let totalKm = 0
  let totalTime = 0
  const nameCenterPoint: Array<string> = []
  data.data.forEach((item: any) => {
    if (item.routes && item.routes[0]) {
      item.routes[0].legs.forEach((leg: any) => {
        if (leg.distance && leg.distance.value) {
          totalKm += leg.distance.value || 0
          totalTime += leg.duration.value || 0
        }
        nameCenterPoint.push(leg.start_address)
      })
    }
  })
  dataFormSubmitRouting.distanceCenterPoint = formatDistanceToKm(totalKm)
  dataFormSubmitRouting.timeCenterPoint = formatTime(totalTime)
  Object.assign(dataFormSubmitRouting.routesCenterPoint, nameCenterPoint)
}
</script>
